<template>
  <main-layout
    class="damage"
    page-title="专家咨询"
    :tabs="tabs"
    :tab-id="currentTabId"
    custom-back
    @listen-back="goBack"
    @changeTab="changeTab"
  >
    <div v-if="currentTabId === 0" slot="main-content" class="main-content">
      <el-form
        :inline="true"
        size="medium"
        :model="formInline"
        class="demo-form-inline"
      >
        <el-form-item>
          <el-select
            v-model="formInline.queryType"
            filterable
            clearable
            @change="getList"
            placeholder="请选择问题分类"
          >
            <el-option
              v-for="({ label, value }, index) in options"
              :key="index"
              :value="value"
              :label="label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="formInline.time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            value-format="yyyy-MM-dd"
            end-placeholder="结束日期"
            @change="getList"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="flr">
          <el-button
            type="primary"
            v-if="permissionResultList[0]"
            @click="handInitiateConsultation"
          >
            发起咨询
          </el-button>
        </el-form-item>
      </el-form>
      <el-card v-loading="loading" class="box-card">
        <question
          v-for="(item, index) in list"
          :key="index"
          :questionData="item"
          @backData="backData"
          @getList="getList"
          :permissionResultList="permissionResultList"
        ></question>
        <el-empty v-if="!list.length" description="暂无数据"></el-empty>
      </el-card>
      <pagiation
        :total="total"
        :pageSize="formInline.pageSize"
        :pageNo="formInline.pageNo"
        @currentChange="currentChange"
        :pagisShow="pagisShow"
      />
      <consultDialog
        :dialogVisible="visible"
        @closeDialog="closeDialog"
        :isconsult="isconsult"
        :queryId="queryId"
      ></consultDialog>
    </div>
    <div v-else slot="main-content" class="main-content">
      <iframe
        src="https://aichat.snkoudai.com/ui/chat/01dd6363658a0c71"
        style="width: 100%; height: 100%"
        frameborder="0"
        allow="microphone"
      >
      </iframe>
    </div>
  </main-layout>
</template>
<script>
import MainLayout from "@/layout/MainLayout";
import question from "./components/question.vue";
import consultDialog from "./components/consultDialog.vue";
import Pagiation from "@/components/Pagiation.vue";
import { windowHref } from "@/utils";
import {
  expertConsultation,
  getFarmModulesByCode,
} from "@/api/request/snkd.produce";
import { mapActions } from "vuex";

export default {
  components: {
    MainLayout,
    question,
    consultDialog,
    Pagiation,
  },
  data() {
    return {
      formInline: {
        queryType: "",
        time: "",
        pageNo: 1,
        pageSize: 20,
        loadAnswer: 1,
        sortDirection: "desc",
        sortField: "id",
        queryStatus: [0, 1],
      },
      total: 0,
      pagisShow: true,
      queryId: null,
      list: [],
      options: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "APP使用帮助",
          value: 1,
        },
        {
          label: "政策相关",
          value: 2,
        },
        {
          label: "农技相关",
          value: 3,
        },
        {
          label: "未分类",
          value: 0,
        },
      ],
      visible: false,
      isconsult: true,
      loading: false,
      isShow: false,
      permissionResultList: [],
      tabs: [],
      currentTabId: -1,
    };
  },
  provide() {
    return {
      getList: this.getList,
    };
  },
  async created() {
    await this.judgeAi();
    this.currentTabId = Number(this.$route.query.tab) || 0;
    await this.permissionFun();
    if (this.currentTabId === 0) {
      await this.getList();
    }
  },
  methods: {
    ...mapActions("permission", ["hasPermission"]),
    async permissionFun() {
      try {
        let permissionList = [
          "produce:ExpertConsultation:consult",
          "produce:ExpertConsultation:deleteQuestion",
          "produce:ExpertConsultation:probe",
          "produce:ExpertConsultation:deleteReply",
        ];
        for (let index = 0; index < permissionList.length; index++) {
          const item = permissionList[index];
          let res = await this.hasPermission(item);
          this.permissionResultList.push(res);
        }
      } catch (error) {
        console.log(error);
      }
    },
    goBack() {
      windowHref("/home/home");
    },
    changeTab(tab) {
      this.currentTabId = tab.id;
      if (this.currentTabId === 0) {
        this.getList();
      }
    },
    handInitiateConsultation() {
      this.visible = true;
    },
    closeDialog() {
      this.isconsult = true;
      this.visible = false;
      this.queryId = null;
      this.getList();
    },
    backData(id) {
      this.isconsult = false;
      this.visible = true;
      this.queryId = id;
    },
    selectChange() {
      this.formInline.pageNo = 1;
      this.getList();
    },
    currentChange(pageNo) {
      this.formInline.pageNo = pageNo;
      this.getList();
    },
    async getList() {
      this.loading = true;
      try {
        const [createTimeStart, createTimeEnd] = this.formInline.time || [];
        const body = {
          ...this.formInline,
          createTimeStart: createTimeStart || "",
          createTimeEnd: createTimeEnd || "",
          queryType:
            this.formInline.queryType !== "" ? [this.formInline.queryType] : [],
        };
        const { list, totalCount } = await expertConsultation.queryPageList(
          body
        );
        this.total = totalCount;
        this.list = list;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async judgeAi() {
      const { obj } = await getFarmModulesByCode({ code: "jiqiren" });
      if (obj) {
        this.tabs = [
          {
            id: 0,
            name: "专家咨询",
          },
          {
            id: 1,
            name: "AI咨询",
          },
        ];
      }
    },
  },
};
</script>
<style scoped lang="scss">
.main-content {
  width: 1200px;
  height: 100%;
  background: #fff;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}

.flr {
  float: right;
}
</style>
